module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Anchor-right-1e831089aba3cf0434a5da131334e28c.svg";